import catTaste from "@/assets/discover/cat-taste.jpg";
import catCulture from "@/assets/discover/cat-culture.jpg";
import catHistory from "@/assets/discover/cat-history.jpg";
import catIslandLife from "@/assets/discover/cat-island-life.jpg";
import catFestivals from "@/assets/discover/cat-festivals.jpg";
import catExperiences from "@/assets/discover/cat-experiences.jpg";
import catForest from "@/assets/forest/living-forest-section.jpg.asset.json";
import catMusic from "@/assets/discover/music/music-hero.jpg";

export interface DiscoverCategory {
  slug: string;
  title: string;
  shortTitle: string;
  intro: string;
  image: string;
}

export const DISCOVER_CATEGORIES: DiscoverCategory[] = [
  {
    slug: "taste-of-st-kitts",
    title: "Taste of St. Kitts",
    shortTitle: "Taste",
    intro:
      "Heritage recipes, market-day flavors, and the foods that define life on the island — from guava cheese and goat water to sugar cake and bush tea.",
    image: catTaste,
  },
  {
    slug: "curious-visitor-faq",
    title: "Before You Arrive",
    shortTitle: "Before You Arrive",
    intro:
      "Everything a thoughtful first-time visitor wonders about — size, currency, language, customs, and the small details that make St. Kitts & Nevis unmistakable.",
    image: catCulture,
  },
  {
    slug: "forest-island",
    title: "Forest Island",
    shortTitle: "Forest",
    intro:
      "Beyond the beaches lies another St. Kitts — volcanic rainforest, cloud forests, hidden trails, healing plants, forest foods, and the survival stories carried through generations.",
    image: catForest.url,
  },
  {
    slug: "nature-geography",
    title: "Nature & Geography",
    shortTitle: "Nature",
    intro:
      "Vervet monkeys, rainforest trails, volcanic peaks, and the place where the Atlantic meets the Caribbean — the wild, green soul of the islands.",
    image: catIslandLife,
  },
  {
    slug: "history-heritage",
    title: "History & Heritage",
    shortTitle: "History",
    intro:
      "Sugar mill ruins, Brimstone Hill, colonial-era stories, and the African and Caribbean roots that shaped St. Kitts and Nevis.",
    image: catHistory,
  },
  {
    slug: "festivals-traditions",
    title: "Festivals & Traditions",
    shortTitle: "Festivals",
    intro:
      "Sugar Mas, Culturama, Christmas sorrel and black cake, ginger beer rituals — the celebrations that bring the island into the streets.",
    image: catFestivals,
  },
  {
    slug: "experience-it-like-a-local",
    title: "Experience It Like a Local",
    shortTitle: "Experience",
    intro:
      "Bookable workshops, heritage tastings, getting around, and immersive ways to step beyond the resort and into real Kittitian life.",
    image: catExperiences,
  },
  {
    slug: "music-in-st-kitts-nevis",
    title: "Music in St. Kitts & Nevis",
    shortTitle: "Music",
    intro:
      "Calypso, soca, steelpan, fife and drum, and traditional masquerade — the rhythms that carry the island's memory, identity, and celebration.",
    image: catMusic,
  },
];

export const findCategory = (slug?: string) =>
  DISCOVER_CATEGORIES.find((c) => c.slug === slug);
